<template>
  <!-- <CContainer class="d-flex align-items-center min-vh-100"> -->
    <CRow class="p-2">
      <CCol sm="12">
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm @submit.prevent="login" method="POST">
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>
                <CInput
                  v-model="email"
                  prependHtml="<i class='cui-user'></i>"
                  placeholder="Username"
                  autocomplete="username email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  v-model="password"
                  prependHtml="<i class='cui-lock-locked'></i>"
                  placeholder="Password"
                  type="password"
                  autocomplete="curent-password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton type="submit" color="danger" class="px-4">Login</CButton>
                  </CCol>
                  <CCol col="6" class="text-right">
                    <CButton color="link" class="px-0" @click="$router.push('/forgot_password')">Forgot password?</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          <CCard
            color="danger"
            text-color="white"
            class="text-center py-5 d-md-down-none"
            body-wrapper
          >
            <h2>Welcome!</h2>
            <p>Welcome to our new order entry system. Please login using your email and password you've been assigned.</p>
            <!-- <CButton
              color="primary"
              class="active mt-3"
              @click="goRegister()"
            >
              Register Now!
            </CButton> -->
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  <!-- </CContainer> -->
</template>

<script>
import Swal from 'sweetalert2'
    export default {
      name: 'Login',
      data() {
        return {
          email: '',
          password: '',
          showMessage: false,
          message: '',
        }
      },
      mounted: function () {
        console.log('in login')
      },
      watch: {
        '$store.state.user': function (newVal, oldVal) {
          console.log('user changed')
          // this.$router.push({ path: 'dashboard' });
          if (this.$route.params.nextUrl) {
            this.$router.push({path: this.$route.params.nextUrl})
          } else {
            this.$router.push('/dashboard')
          }
        }
      },
      methods: {
        goRegister(){
          this.$router.push({ path: 'register' });
        },
        login() {
          let self = this;
          axios.post( this.$apiAdress + '/api/login', {
            email: self.email,
            password: self.password,
          }).then(response => {
            console.log(response)
            if (response.status === 200 || response.status === 200) {
              self.email = '';
              self.password = '';
              console.log('loging in')
              console.log(response)
              localStorage.setItem("api_token", response.data.access_token);
              localStorage.setItem('roles', response.data.roles);
              self.$store.commit('fetchUser')
            }
          })
          .catch(function (error) {
            self.message = 'Incorrect E-mail or password';
            self.showMessage = true;
            Swal.fire({
              type: 'error',
              title: 'Oops!',
              text: 'Email or password incorrect.'
            })
            console.log(error);
          });
  
        }
      }
    }

</script>
